export default {
  prints: [],
  print: null,
  isPrintSaved: false
};

